import { Group, Text } from "@mantine/core";
import { ReactElement } from "react";

const OPACITY_ACTIVE = 1;
const OPACITY_INACTIVE = 0.4;

type CustomLegendProps = {
    datasets: Record<
        string,
        {
            label: string;
            color: string;
        }
    >;
    visibleKeys: Set<string>;
    toggleKeyVisibility: (key: string) => void;
};

export const CustomLegend = ({
    datasets,
    visibleKeys,
    toggleKeyVisibility,
}: CustomLegendProps): ReactElement => (
    <Group spacing="16px">
        {Object.entries(datasets).map(([key, { label, color }]) => {
            const isActive = visibleKeys.has(key);

            return (
                <Group
                    key={key}
                    onClick={(): void => toggleKeyVisibility(key)}
                    spacing="4px"
                    style={{
                        cursor: "pointer",
                        opacity: isActive ? OPACITY_ACTIVE : OPACITY_INACTIVE,
                        userSelect: "none",
                    }}
                >
                    <svg width={12} height={12}>
                        <circle fill={color} r={6} cx={6} cy={6} />
                    </svg>

                    <Text size="sm">{label}</Text>
                </Group>
            );
        })}
    </Group>
);
